var _g, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    viewBox: "0 0 37 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1399_1552)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.6791 15.2086H19.2994V12.9554C19.2994 12.6567 19.4181 12.3701 19.6293 12.1588C19.8406 11.9476 20.1271 11.8289 20.4259 11.8289H21.5525V9.01245H19.2994C18.403 9.01245 17.5434 9.36853 16.9095 10.0023C16.2757 10.6362 15.9196 11.4958 15.9196 12.3922V15.2086H13.6665V18.025H15.9196V27.0376H19.2994V18.025H21.5525L22.6791 15.2086Z",
    fill: "white"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18.175,
    cy: 18.0251,
    r: 17.6496,
    stroke: "#5D5D5D",
    strokeWidth: 0.751047
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1399_1552"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.0251,
    height: 18.0251,
    fill: "white",
    transform: "translate(9.16211 9.01245)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFb);
export default __webpack_public_path__ + "static/media/fb.cdb6ddfdfb99a8e8072caf80e715f2d9.svg";
export { ForwardRef as ReactComponent };